import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import Swal from "sweetalert2";
import { User, Comment, Discussion, PanelMember } from "../../../../models";

@Component({
  selector: "comment-editor-modal",
  templateUrl: "./comment-editor-modal.component.html",
  styleUrls: [
    "./comment-editor-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CommentEditorModal implements OnInit {
  // variables to pass on to modal form
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() commentRepliedTo: Comment;
  @Input() commentToEdit: Comment;

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    if (
      this.discussion.community.isMember === true ||
      this.currentPanelMember
    ) {
      this.visible = true;
      setTimeout(() => (this.visibleAnimate = true), 100);
    } else {
      this.openNonMemberAlert();
    }
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }

  public openNonMemberAlert() {
    Swal.fire({
      title: "Askies, Sorry!",
      text: "Only members of this uMuzi can comment, please ask a member to invite you",
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Mxm ok!",
    });
  }
}
